import Link from 'next/link'
import { SearchX } from 'lucide-react'

interface EmptyStateProps {
    title: string
    description?: string
    actionLabel?: string
    /** When set, the action renders as a link. */
    actionHref?: string
    /** When set, the action renders as a button (takes priority over actionHref). */
    onAction?: () => void
}

const actionClass =
    'inline-flex items-center justify-center rounded-full bg-[#ff5e20] px-7 py-3 text-base font-semibold text-white transition-colors duration-200 hover:bg-[#e54e15] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ff5e20]/50'

export function EmptyState({ title, description, actionLabel, actionHref, onAction }: EmptyStateProps) {
    return (
        <div className='flex min-h-[440px] flex-col items-center justify-center rounded-2xl border border-white/10 bg-white/[0.02] px-6 py-16 text-center'>
            <div className='mb-6 flex size-16 items-center justify-center rounded-full border border-white/10 bg-white/[0.03]'>
                <SearchX className='size-7 text-[#ff5e20]' aria-hidden />
            </div>

            <h3 className='mb-3 text-2xl font-semibold tracking-tight text-white md:text-[1.75rem]'>{title}</h3>

            {description && <p className='mb-8 max-w-md text-base leading-relaxed text-white/55'>{description}</p>}

            {actionLabel && onAction && (
                <button type='button' onClick={onAction} className={actionClass}>
                    {actionLabel}
                </button>
            )}

            {actionLabel && !onAction && actionHref && (
                <Link href={actionHref} className={actionClass}>
                    {actionLabel}
                </Link>
            )}
        </div>
    )
}
